import {moduleNamespace} from './constants';

/**
 * Shared methods
 */
import {
  getItemFromSession,
  getObjectFromSession,
} from '../../sharedGlobal'; // Globally shared

/**
 * The default state of the setup wizard on page load.
 */
const defaultWizardState = () => ({
  currentStep: getItemFromSession(moduleNamespace,'currentStep') ?? 'CUSTOM_DOMAIN', // TODO: STEPS[0]?

  customDomainStatus: null,
  customEmailStatus: null,

  formFields: {
    customDomain: formFieldFromSession('customDomain') ?? null,
    customEmail: formFieldFromSession('customEmail') ?? null,
    fromName: formFieldFromSession('fromName') ?? null,
  },

  registration: getObjectFromSession(moduleNamespace, 'registration') ?? {
    title: "You’re 1 Min Away From Getting Started",
    subtitle: 'Take the first step in better SEO!', // TODO: Something better
    logo: null,
  },

  taxConfig: getObjectFromSession(moduleNamespace, 'taxConfig') ?? {
    charging: false,
    percentage: 20,
    countries: [],
  },

  countries: {},

  whitelabelLogo: null,
  errors: {},
  loading: false,

  stripeAccountError: null,
});

import getters from './getters';
import actions from './actions';
import mutations from './mutations';
import {formFieldFromSession} from "./methods";
export default {
  namespaced: true,
  state: defaultWizardState(),
  getters,
  actions,
  mutations,
};
